import _ from 'lodash';

import { mapDateTimesToMoments } from '../utils/timeUtils';

import {
  BOOKINGS_LOADING,
  BOOKINGS_SUCCESS,
  BOOKINGS_ERROR,
  BOOKINGS_PERIOD_LOADING,
  BOOKINGS_PERIOD_SUCCESS,
  BOOKINGS_PERIOD_ERROR,
  PENDING_BOOKINGS_LOADING,
  PENDING_BOOKINGS_SUCCESS,
  PENDING_BOOKINGS_ERROR
} from '../actions/bookingActions';
import { CANCEL_BOOKING, RESCHEDULE_BOOKING } from '../actions/reservationActions';

const INITIAL_STATE = {
  bookings: [],
  status: null,
  periodBookings: [],
  periodBookingsStatus: 'INIT',
  pendingBookings: [],
  pendingBookingsStatus: 'INIT',
  error: null
};

export default function bookingsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case BOOKINGS_LOADING:
      return { 
        ...state, 
        status: 'LOADING' 
      };

    case BOOKINGS_SUCCESS:
      const bookingsWithMoments = mapDateTimesToMoments(action.payload.data.data);

      return {
        ...state,
        error: null,
        status: 'SUCCESS',
        totalBookings: action.total,
        pageSize: action.page_size,
        bookings: bookingsWithMoments
      };

    case BOOKINGS_ERROR:
      const { status, statusText } = action.payload.response;
      const { message } = action.payload;

      return { error: { status, statusText, message } };

    case CANCEL_BOOKING:
      return {
        ...state,
        bookings: _.filter(state.bookings, b => b.id !== action.id)
      };

    case BOOKINGS_PERIOD_LOADING:
      return {
        ...state,
        periodBookingsStatus: 'LOADING'
      };

    case BOOKINGS_PERIOD_SUCCESS:
      return {
        ...state,
        error: null,
        periodBookings: action.payload,
        totalBookings: action.total,
        pageSize: action.page_size,
        periodBookingsStatus: 'SUCCESS'
      };

    case BOOKINGS_PERIOD_ERROR:
      return {
        ...state,
        periodBookings: [],
        error: { message: action.payload.error },
        periodBookingsStatus: 'FAIL'
      };

    case PENDING_BOOKINGS_LOADING:
      return {
        ...state,
        pendingBookingsStatus: 'LOADING'
      };

    case PENDING_BOOKINGS_SUCCESS:
      return {
        ...state,
        error: null,
        pendingBookings: action.payload,
        totalBookings: action.total,
        pageSize: action.page_size,
        pendingBookingsStatus: 'SUCCESS'
      };

    case PENDING_BOOKINGS_ERROR:
      return {
        ...state,
        pendingBookings: [],
        error: { message: action.payload.error },
        pendingBookingsStatus: 'FAIL'
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/bookingsReducer.js